/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Promise = require('babel-runtime/core-js/promise')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _reduxModulesAdGroup = require('redux/modules/adGroup');

var _reduxModulesArticles = require('redux/modules/articles');

var _reduxModulesTheDrip = require('redux/modules/theDrip');

var _reduxModulesColdBrew = require('redux/modules/coldBrew');

var _reduxModulesSpecialSeriesRollup = require('redux/modules/specialSeriesRollup');

var _reduxModulesMostPopular = require('redux/modules/mostPopular');

var _reduxModulesRecentComments = require('redux/modules/recentComments');

var _reduxModulesSubscribeModal = require('redux/modules/subscribeModal');

var _lodashFind = require('lodash/find');

var _lodashFind2 = _interopRequireDefault(_lodashFind);

var _lodashIsEmpty = require('lodash/isEmpty');

var _lodashIsEmpty2 = _interopRequireDefault(_lodashIsEmpty);

var _lodashFilter = require('lodash/filter');

var _lodashFilter2 = _interopRequireDefault(_lodashFilter);

var _components = require('components');

var Home = (function (_Component) {
	_inherits(Home, _Component);

	function Home() {
		_classCallCheck(this, _Home);

		_Component.apply(this, arguments);

		this.state = {
			showSidebar: false,
			isSmallViewport: false
		};
	}

	Home.prototype.componentDidMount = function componentDidMount() {
		var _this = this;
		var enquire = require('../../../static/js/enquire');
		enquire.register('(min-width:' + _srcSettings2['default'].media.medium + ')', {
			match: function match() {
				_this.setState({ showSidebar: true });
			},
			unmatch: function unmatch() {
				_this.setState({ showSidebar: false });
			}
		});
	};

	Home.fetchData = function fetchData(getState, dispatch) {
		var promises = [];
		var state = getState();

		if (!_reduxModulesAdGroup.isLoaded(state)) {
			promises.push(dispatch(_reduxModulesAdGroup.load('118259,118278')));
		}

		if (!_reduxModulesArticles.isLoaded(state)) {
			promises.push(dispatch(_reduxModulesArticles.load(20)));
		}

		if (!_reduxModulesTheDrip.isLoaded(state)) {
			promises.push(dispatch(_reduxModulesTheDrip.load(5)));
		}

		if (!_reduxModulesColdBrew.isLoaded(state)) {
			promises.push(dispatch(_reduxModulesColdBrew.load()));
		}

		if (!_reduxModulesSpecialSeriesRollup.isLoaded(state)) {
			promises.push(dispatch(_reduxModulesSpecialSeriesRollup.load(10)));
		}

		if (!_reduxModulesMostPopular.isLoaded(state)) {
			promises.push(dispatch(_reduxModulesMostPopular.load()));
		}

		if (!_reduxModulesRecentComments.isLoaded(state)) {
			promises.push(dispatch(_reduxModulesRecentComments.load()));
		}

		return _Promise.all(promises);
	};

	Home.prototype.render = function render() {
		var _classNames;

		var _props = this.props;
		var articles = _props.articles;
		var ads = _props.ads;
		var coldBrew = _props.coldBrew;
		var isMediumViewport = _props.isMediumViewport;
		var isSmallViewport = _props.isSmallViewport;

		var styles = require('./Home.css');

		var mainColumnClasses = _classnames2['default']((_classNames = {}, _classNames[styles['Column--main']] = true, _classNames[styles['Column--withSidebar']] = this.state.showSidebar, _classNames));

		/* Set up image ads */
		var adsTop = _lodashFind2['default'](ads, function (ad) {
			return ad.position === 'top';
		});
		var adsTopSquare = undefined;
		var adsTopLeaderboard = undefined;
		if (!_lodashIsEmpty2['default'](adsTop)) {
			// Get all 300×250 ads
			adsTopSquare = _lodashFilter2['default'](adsTop.ads, function (ad) {
				return ad.title.indexOf('300x250') > -1;
			});
			// Get all 728x90 ads
			adsTopLeaderboard = _lodashFilter2['default'](adsTop.ads, function (ad) {
				return ad.title.indexOf('728x90') > -1;
			});
		}

		var adsBottom = _lodashFind2['default'](ads, function (ad) {
			return ad.position === 'bottom';
		});
		var adsBottomSquare = undefined;
		if (!_lodashIsEmpty2['default'](adsBottom)) {
			// Get all 300×250 ads
			adsBottomSquare = _lodashFilter2['default'](adsBottom.ads, function (ad) {
				return ad.title.indexOf('300x250') > -1;
			});
		}

		if (!articles) return false;
		return _react2['default'].createElement(
			'main',
			{ className: styles.Base },
			_react2['default'].createElement(_reactHelmet2['default'], { title: 'Home' }),
			_react2['default'].createElement(
				'div',
				{ className: mainColumnClasses },
				_react2['default'].createElement(
					'section',
					{ className: styles['Articles--featured'] },
					_react2['default'].createElement(_components.FeaturedArticleBlock, {
						author: articles[0].author.guest ? articles[0].author.guest[0] : articles[0].author.name,
						authorURI: articles[0].author.guest ? false : articles[0].author.slug,
						categories: articles[0].categories,
						className: styles.FeaturedArticle,
						content: articles[0].excerpt,
						imageSrc: articles[0].images['bbrew-feature'][0],
						postDate: articles[0].date,
						specialSeries: articles[0].specialSeries || null,
						title: articles[0].title,
						uri: articles[0].url
					})
				),
				_react2['default'].createElement(
					'section',
					{ className: styles.Articles },
					_react2['default'].createElement(
						'div',
						{ className: styles['ArticleRow--split'] },
						_react2['default'].createElement(_components.ArticleBlock, {
							categories: articles[1].categories,
							className: styles['Article--half'],
							content: articles[1].excerpt,
							imageSrc: articles[1].images['bbrew-feature-small'][0],
							postDate: articles[1].date,
							sansOrSerif: 'serif',
							specialSeries: articles[1].specialSeries || null,
							stretched: false,
							title: articles[1].title,
							uri: articles[1].url
						}),
						_react2['default'].createElement(_components.ArticleBlock, {
							className: styles['Article--half'],
							imageSrc: articles[2].images['bbrew-feature-small'][0],
							categories: articles[2].categories,
							postDate: articles[2].date,
							title: articles[2].title,
							content: articles[2].excerpt,
							uri: articles[2].url,
							sansOrSerif: 'sans',
							specialSeries: articles[2].specialSeries || null,
							stretched: false
						})
					),
					_react2['default'].createElement(
						'div',
						{ className: styles.ArticleRow },
						_react2['default'].createElement(_components.ArticleBlock, {
							className: styles.Article,
							imageSrc: articles[3].images['bbrew-feature-small'][0],
							categories: articles[3].categories,
							postDate: articles[3].date,
							title: articles[3].title,
							content: articles[3].excerpt,
							uri: articles[3].url,
							sansOrSerif: 'serif',
							specialSeries: articles[3].specialSeries || null,
							stretched: !isSmallViewport
						})
					),
					_react2['default'].createElement(
						'div',
						{ className: styles['ArticleRow--split'] },
						_react2['default'].createElement(_components.ArticleBlock, {
							className: styles['Article--half'],
							categories: articles[4].categories,
							postDate: articles[4].date,
							title: articles[4].title,
							content: articles[4].excerpt,
							uri: articles[4].url,
							sansOrSerif: 'sans',
							specialSeries: articles[4].specialSeries || null,
							stretched: false
						}),
						_react2['default'].createElement(_components.ArticleBlock, {
							className: styles['Article--half'],
							categories: articles[5].categories,
							postDate: articles[5].date,
							title: articles[5].title,
							content: articles[5].excerpt,
							uri: articles[5].url,
							sansOrSerif: 'serif',
							specialSeries: articles[5].specialSeries || null,
							stretched: false
						})
					),
					!this.state.showSidebar && !isSmallViewport ? _react2['default'].createElement(
						'div',
						{ className: styles['ArticleRow--split-wide'] },
						_react2['default'].createElement(_components.TheDrip, { className: styles['TheDrip--inline'] }),
						_react2['default'].createElement(_components.SpecialSeriesRollup, { className: styles.SpecialSeries })
					) : null,
					isSmallViewport ? _react2['default'].createElement(
						'div',
						{ className: styles.ArticleRow },
						_react2['default'].createElement(_components.TheDrip, { className: styles['TheDrip--inline'] })
					) : null,
					(isSmallViewport || isMediumViewport) && adsTopSquare.length && _react2['default'].createElement(
						'div',
						{ className: styles['ArticleRow--doubleAdRow'] },
						_react2['default'].createElement(
							'div',
							{ className: styles['Article--half'] },
							_react2['default'].createElement(
								_components.Ad,
								{
									className: styles.Ad,
									href: adsTopSquare[0].url,
									ratio: '4x3',
									target: '_blank'
								},
								_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + adsTopSquare[0].image.src, alt: adsTopSquare[0].image.title })
							)
						),
						_react2['default'].createElement(
							'div',
							{ className: styles['Article--half'] },
							_react2['default'].createElement(
								_components.Ad,
								{ href: '/support', ratio: '4x3', onClick: this.props.openModal },
								_react2['default'].createElement('img', { className: styles.Image, src: _srcSettings2['default'].cdn + '/content/uploads/ads/ad-a.jpg', alt: '' })
							)
						)
					),
					isSmallViewport ? _react2['default'].createElement(
						'div',
						{ className: styles.ArticleRow },
						_react2['default'].createElement(_components.SpecialSeriesRollup, { className: styles.SpecialSeries })
					) : null
				),
				!isSmallViewport && adsTopLeaderboard.length && _react2['default'].createElement(
					'section',
					{ className: styles.AdSpace },
					_react2['default'].createElement(
						_components.Ad,
						{
							className: styles.Ad,
							href: adsTopLeaderboard[0].url,
							ratio: '8x1',
							target: '_blank'
						},
						_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + adsTopLeaderboard[0].image.src, alt: adsTopLeaderboard[0].image.title })
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.ArchiveRow },
					_react2['default'].createElement(_components.ColdBrew, {
						author: coldBrew.author.guest ? coldBrew.author.guest[0] : coldBrew.author.name,
						authorURI: coldBrew.author.guest ? false : coldBrew.author.slug,
						categories: coldBrew.categories,
						className: styles.ColdBrew,
						content: coldBrew.excerpt,
						horizontal: !isSmallViewport,
						imageSrc: coldBrew.images['bbrew-medium'][0],
						date: coldBrew.date,
						title: coldBrew.title,
						uri: coldBrew.url
					})
				),
				_react2['default'].createElement(
					'section',
					{ className: styles.RecentNews },
					_react2['default'].createElement(_components.RecentNews, null)
				),
				!this.state.showSidebar && !isSmallViewport && _react2['default'].createElement(
					'div',
					{ className: styles.ArticleRow },
					_react2['default'].createElement(
						'div',
						{ className: styles['Article--half'] },
						_react2['default'].createElement(_components.InstagramPhoto, { className: styles.Instagram }),
						_react2['default'].createElement(_components.MostPopular, { className: styles['MostPopular--sidebar'] })
					),
					_react2['default'].createElement(
						'div',
						{ className: styles['Article--half'] },
						_react2['default'].createElement(_components.RecentComments, { className: styles.RecentComments })
					)
				),
				isSmallViewport ? _react2['default'].createElement(
					'div',
					{ className: styles.ArticleRow },
					_react2['default'].createElement(_components.MostPopular, { className: styles['MostPopular--inline'] }),
					_react2['default'].createElement(_components.InstagramPhoto, { className: styles.Instagram })
				) : null,
				isSmallViewport && _react2['default'].createElement(
					'div',
					{ className: styles['Article--half'] },
					_react2['default'].createElement(_components.RecentComments, { className: styles.RecentComments })
				),
				_react2['default'].createElement(
					'div',
					{ className: styles['ArticleRow--noBorder'] },
					_react2['default'].createElement(
						'div',
						{ className: styles.SocialEndcap },
						_react2['default'].createElement(
							'p',
							{ className: styles.SocialMessage },
							'Get the freshest brew and join our community of informed readers:'
						),
						_react2['default'].createElement(
							'p',
							{ className: styles.SocialLinks },
							_react2['default'].createElement(
								'a',
								{ className: styles['SocialLink--facebook'], href: _srcSettings2['default'].links.facebook },
								'Facebook'
							),
							_react2['default'].createElement(
								'a',
								{ className: styles['SocialLink--twitter'], href: _srcSettings2['default'].links.twitter },
								'Twitter'
							)
						)
					)
				)
			),
			this.state.showSidebar && _react2['default'].createElement(
				'section',
				{ className: styles['Column--sidebar'] },
				_react2['default'].createElement(
					'div',
					{ className: styles.SidebarBlock },
					_react2['default'].createElement(_components.TheDrip, { className: styles['TheDrip--sidebar'] })
				),
				adsTopSquare && adsTopSquare.length > 0 && _react2['default'].createElement(
					'div',
					{ className: styles.SidebarBlock },
					_react2['default'].createElement(
						_components.Ad,
						{
							className: styles.Ad,
							href: adsTopSquare[0].url,
							ratio: '4x3' },
						_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + adsTopSquare[0].image.src, alt: adsTopSquare[0].image.title })
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.SidebarBlock },
					_react2['default'].createElement(
						_components.Ad,
						{ href: '/support', ratio: '4x3', onClick: this.props.openModal },
						_react2['default'].createElement('img', { className: styles.Image, src: _srcSettings2['default'].cdn + '/content/uploads/ads/ad-a.jpg', alt: '' })
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.SidebarBlock },
					_react2['default'].createElement(_components.SpecialSeriesRollup, null)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.SidebarBlock },
					_react2['default'].createElement(_components.MostPopular, { className: styles['MostPopular--sidebar'] })
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.SidebarBlock },
					_react2['default'].createElement(_components.InstagramPhoto, { className: styles.Instagram })
				),
				adsBottomSquare && adsBottomSquare.length > 0 && _react2['default'].createElement(
					'div',
					{ className: styles.SidebarBlock },
					_react2['default'].createElement(
						_components.Ad,
						{
							className: styles.Ad,
							href: adsBottomSquare[0].url,
							ratio: '4x3' },
						_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + adsBottomSquare[0].image.src, alt: adsBottomSquare[0].image.title })
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.SidebarBlock },
					_react2['default'].createElement(_components.RecentComments, null)
				)
			)
		);
	};

	_createClass(Home, null, [{
		key: 'propTypes',
		value: {
			adIsLoaded: _react.PropTypes.bool,
			ads: _react.PropTypes.array,
			articles: _react.PropTypes.array,
			articlesError: _react.PropTypes.object,
			articlesLoading: _react.PropTypes.bool,
			authors: _react.PropTypes.array,
			categories: _react.PropTypes.array,
			coldBrew: _react.PropTypes.object,
			isSmallViewport: _react.PropTypes.bool,
			isMediumViewport: _react.PropTypes.bool,
			loaded: _react.PropTypes.bool,
			openModal: _react.PropTypes.func.isRequired
		},
		enumerable: true
	}]);

	var _Home = Home;
	Home = _reactRedux.connect(function (state) {
		return {
			adIsLoaded: state.ad.isLoaded,
			ads: state.adGroup.data,
			articles: state.articles.data,
			articlesError: state.articles.error,
			articlesLoading: state.articles.loading,
			authors: state.authors.data,
			categories: state.categories.data,
			coldBrew: state.coldBrew.data,
			isSmallViewport: state.responsive.isSmallViewport,
			isMediumViewport: state.responsive.isMediumViewport,
			loaded: state.articles.loaded,
			mostPopular: state.mostPopular.data,
			recentComments: state.recentComments.data,
			specialSeriesRollup: state.specialSeriesRollup.data,
			theDrip: state.theDrip.data
		};
	}, { openModal: _reduxModulesSubscribeModal.open })(Home) || Home;
	return Home;
})(_react.Component);

exports['default'] = Home;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Home/Home.js
 ** module id = 702
 ** module chunks = 0
 **/